import React, { useMemo, useCallback } from 'react';
import { Select } from '@panwds/react-ui';
import { useFilters } from '../../../hooks/useFilters/useFilters.esm.js';
import { actions } from '../../../state/actions.esm.js';
import '../../../state/reducer.esm.js';
import { AddButton } from './AddButton.esm.js';

var AddFilter = function (_a) {
    var normalizedFilterConfig = _a.normalizedFilterConfig, disabled = _a.disabled, isLoading = _a.isLoading, onAddFilter = _a.onAddFilter;
    var _b = useFilters(), displayedFilters = _b.displayedFilters, dispatch = _b.dispatch, name = _b.name;
    var items = useMemo(function () {
        return Object.values(normalizedFilterConfig).map(function (filter) { return ({
            children: filter.label,
            value: filter.name,
            disabled: filter.isDisplayed || filter.disabled
        }); });
    }, [normalizedFilterConfig]);
    var addFilter = useCallback(function (_a) {
        var selectedItem = _a.selectedItem;
        dispatch({
            type: actions.displayFilter,
            payload: {
                name: name,
                filterName: selectedItem.value
            }
        });
        onAddFilter(selectedItem.value);
    }, [name]);
    return (React.createElement(Select, { button: React.createElement(AddButton, { disabled: disabled, isLoading: isLoading, showLabel: !displayedFilters.length }), disabled: disabled || isLoading, items: items, selectedItem: null, onChange: addFilter }));
};

export { AddFilter };
//# sourceMappingURL=AddFilter.esm.js.map
